export type ViewMode = 'grid' | 'brand-list' | 'products';

interface ViewToggleProps {
  activeView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const VIEW_OPTIONS: Array<{ mode: ViewMode; icon: string; title: string }> = [
  { mode: 'grid', icon: 'grid_view', title: 'Merken grid' },
  { mode: 'brand-list', icon: 'view_list', title: 'Merken lijst' },
  { mode: 'products', icon: 'table_rows', title: 'Producten' },
];

export function ViewToggle({ activeView, onViewChange }: ViewToggleProps) {
  return (
    <div
      className="flex gap-0.5 rounded-lg p-[3px]"
      style={{ backgroundColor: 'var(--background-muted)' }}
    >
      {VIEW_OPTIONS.map(({ mode, icon, title }) => (
        <button
          key={mode}
          title={title}
          onClick={() => onViewChange(mode)}
          className="flex items-center justify-center rounded-md transition-all duration-150"
          style={{
            width: 36,
            height: 36,
            border: 'none',
            cursor: 'pointer',
            background: activeView === mode ? 'var(--background)' : 'transparent',
            color: activeView === mode ? 'var(--primary)' : 'var(--foreground-muted)',
            boxShadow: activeView === mode ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
          }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
            {icon}
          </span>
        </button>
      ))}
    </div>
  );
}
